<template>
  <div class="video-tile-results">
    <div
      v-for="(items, key) in itemsByParent"
      :key="key"
      class="video-tile-results__parent"
    >
      <ContentParent
        v-if="getParent(items[0], key)"
        :parent="getParent(items[0], key)"
        :parentType="items[0].parent_type"
      />
      <div class="video-tile-results__grid">
        <div
          v-for="item in items"
          :key="item.objectID"
          class="video-tile-results__item"
        >
          <VideoTile
            v-if="getParent(items[0], key)"
            :video="item"
            :backgroundImg="getParentBackground(items[0], key)"
            :gradient="$getGradient()"
            :duration="$duration.getCourseDuration(item)"
            @open-video="handleVideoEmit"
            :parent="getParent(items[0], key)"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapMutations } from 'vuex'
import VideoTile from '@/components/layout/VideoTile.vue'
import ContentParent from '@/components/layout/ContentParent.vue'
import CONSTANTS from '@/constants'

export default {
  name: 'VideoTileResults',
  components: {
    VideoTile,
    ContentParent,
  },
  props: {
    items: {
      type: Array,
      required: true,
    },
    parentsSearchResults: {
      type: Object,
      required: true,
    },
  },
  data: () => {
    return {
      parents: CONSTANTS.SEARCH.PARENTS,
    }
  },
  computed: {
    itemsByParent() {
      // we supose it is very unlikely to have 2 UUIDs repeated from differents parents
      let currentParent = ''
      const parents = this.items.reduce((acc, item) => {
        if (currentParent !== item.parent_id) {
          currentParent = item.parent_id
          acc[currentParent] = [item]
        } else {
          acc[currentParent].push(item)
        }
        return acc
      }, {})
      return parents
    },
  },
  methods: {
    ...mapMutations({
      setParentContent: 'content/CURRENT_PARENT',
    }),
    getParent(item, key) {
      return this.parentsSearchResults[this.parents[item.parent_type]][key]
    },
    getParentBackground(item, key) {
      const parent = this.getParent(item, key)
      let background = ''
      if (!parent) return ''

      // we get directly from parent because it may have another background field
      if (item.parent_type === 'bootcamp') {
        background = parent.background_image_url || ''
      } else {
        background = parent.images ? parent.images.small_image_url : ''
      }

      return background
    },
    handleVideoEmit(video) {
      const parentTypeMap = {
        course: 'course',
        learning_path: 'learning-path',
        bootcamp: 'bootcamp',
      }
      this.setParentContent({
        id: video.parent_id,
        type: parentTypeMap[video.parent_type] || 'course',
      })
      this.$emit('open-video', video)
    },
  },
}
</script>

<style lang="scss" scoped>
.video-tile-results {
  display: flex;
  flex-wrap: wrap;
  width: 100%;
  &__grid {
    display: grid;
    grid-template-rows: auto;
    grid-template-columns: 1fr;
    grid-gap: 10px;
    @include tablet {
      grid-template-columns: 1fr 1fr;
    }
    @include desktop {
      grid-template-columns: 1fr 1fr 1fr;
      grid-gap: 8px;
    }
    @include lg-desktop {
      grid-template-columns: 1fr 1fr 1fr 1fr;
      grid-gap: 10px;
    }
  }
  &__flex-grid {
    display: flex;
    flex-wrap: wrap;
  }
  &__items {
    display: flex;
    flex-wrap: wrap;
    @include tablet {
      padding-left: 30px;
    }
  }
  &__parent {
    display: block;
    position: relative;
    margin-bottom: 4em;
    width: 100%;
  }
}
</style>
